module.exports = __webpack_public_path__ + "img/our5.136c8808.png";